import { TestContext } from 'yup';

const DATE_LENGTH = '99/99/9999'.length;
const DATE_REGEX = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/;

export function validateDate(
  this: TestContext,
  string: string,
  [minAge, maxAge]: number[],
) {
  if (string.length === 0) {
    return true;
  }

  if (string.length < DATE_LENGTH) {
    return false;
  }
  if (!DATE_REGEX.test(string)) {
    return false;
  }

  const [day, month, year] = string.split('/');

  const today = new Date();
  const birthday = new Date(+year, +month - 1, +day);

  let age = today.getFullYear() - birthday.getFullYear();
  const monthDiff = today.getMonth() - birthday.getMonth();
  const dayDiff = today.getDate() - birthday.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff <= 0)) {
    age--;
  }
  if (age < minAge) {
    return this.createError({
      message: `Você deve ser maior de ${minAge} anos`,
    });
  }
  if (age > maxAge) {
    return this.createError({
      message: `Você deve ser menor de ${maxAge} anos`,
    });
  }
  return true;
}
